// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ForbiddenImport } from './routes/forbidden'
import { Route as SplatImport } from './routes/$'
import { Route as IndexImport } from './routes/index'
import { Route as WorkspacesIndexImport } from './routes/workspaces/index'
import { Route as HubIndexImport } from './routes/hub/index'
import { Route as WorkspacesWorkspaceIdImport } from './routes/workspaces/$workspaceId'
import { Route as ProfileSettingsImport } from './routes/profile/settings'
import { Route as ProfileWorkspaceIdImport } from './routes/profile/$workspaceId'
import { Route as OauthInterstitialImport } from './routes/oauth/interstitial'
import { Route as WorkspacesWorkspaceIdIndexImport } from './routes/workspaces/$workspaceId/index'
import { Route as WorkspacesWorkspaceIdUsageImport } from './routes/workspaces/$workspaceId/usage'
import { Route as WorkspacesWorkspaceIdSettingsImport } from './routes/workspaces/$workspaceId/settings'
import { Route as WorkspacesWorkspaceIdMembersImport } from './routes/workspaces/$workspaceId/members'
import { Route as WorkspacesWorkspaceIdHomeImport } from './routes/workspaces/$workspaceId/home'
import { Route as WorkspacesWorkspaceIdChatbotsImport } from './routes/workspaces/$workspaceId/chatbots_'
import { Route as WorkspacesWorkspaceIdBotsImport } from './routes/workspaces/$workspaceId/bots_'
import { Route as WorkspacesWorkspaceIdAuditsImport } from './routes/workspaces/$workspaceId/audits'
import { Route as WorkspacesWorkspaceIdSplatImport } from './routes/workspaces/$workspaceId/$'
import { Route as HubIntegrationsIntegrationIdImport } from './routes/hub/integrations/$integrationId'
import { Route as WorkspacesWorkspaceIdSettingsIndexImport } from './routes/workspaces/$workspaceId/settings/index'
import { Route as WorkspacesWorkspaceIdIntegrationsIndexImport } from './routes/workspaces/$workspaceId/integrations/index'
import { Route as WorkspacesWorkspaceIdSettingsProfileImport } from './routes/workspaces/$workspaceId/settings/profile'
import { Route as WorkspacesWorkspaceIdSettingsSplatImport } from './routes/workspaces/$workspaceId/settings/$'
import { Route as WorkspacesWorkspaceIdProfileSettingsImport } from './routes/workspaces/$workspaceId/profile/settings'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdImport } from './routes/workspaces/$workspaceId/integrations/$integrationId'
import { Route as WorkspacesWorkspaceIdChatbotsBotIdImport } from './routes/workspaces/$workspaceId/chatbots/$botId'
import { Route as WorkspacesWorkspaceIdBotsBotIdImport } from './routes/workspaces/$workspaceId/bots/$botId'
import { Route as WorkspacesWorkspaceIdSettingsBillingIndexImport } from './routes/workspaces/$workspaceId/settings/billing/index'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/index'
import { Route as WorkspacesWorkspaceIdSettingsBillingPlansImport } from './routes/workspaces/$workspaceId/settings/billing/plans'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/versions'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/settings'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/logs'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/$'
import { Route as WorkspacesWorkspaceIdChatbotsBotIdSplatImport } from './routes/workspaces/$workspaceId/chatbots/$botId/$'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat'
import { Route as WorkspacesWorkspaceIdBotsBotIdOverviewImport } from './routes/workspaces/$workspaceId/bots/$botId/overview'
import { Route as WorkspacesWorkspaceIdBotsBotIdLogsImport } from './routes/workspaces/$workspaceId/bots/$botId/logs'
import { Route as WorkspacesWorkspaceIdBotsBotIdHitlImport } from './routes/workspaces/$workspaceId/bots/$botId/hitl'
import { Route as WorkspacesWorkspaceIdBotsBotIdEventsImport } from './routes/workspaces/$workspaceId/bots/$botId/events'
import { Route as WorkspacesWorkspaceIdBotsBotIdConfigurationVariablesImport } from './routes/workspaces/$workspaceId/bots/$botId/configuration-variables'
import { Route as WorkspacesWorkspaceIdBotsBotIdChatImport } from './routes/workspaces/$workspaceId/bots/$botId/chat'
import { Route as WorkspacesWorkspaceIdBotsBotIdAnalyticsImport } from './routes/workspaces/$workspaceId/bots/$botId/analytics'
import { Route as WorkspacesWorkspaceIdBotsBotIdSplatImport } from './routes/workspaces/$workspaceId/bots/$botId/$'
import { Route as WorkspacesWorkspaceIdBotsBotIdIssuesIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/issues/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsIndexImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatStylesImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/styles'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatShareImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/share'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatGeneralImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/general'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatAdvancedSettingsImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/advanced-settings'
import { Route as WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdImport } from './routes/workspaces/$workspaceId/bots/$botId/issues/$issueId'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsMessageMessageIdImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations/message/$messageId'

// Create/Update Routes

const ForbiddenRoute = ForbiddenImport.update({
  path: '/forbidden',
  getParentRoute: () => rootRoute,
} as any)

const SplatRoute = SplatImport.update({
  path: '/$',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const WorkspacesIndexRoute = WorkspacesIndexImport.update({
  path: '/workspaces/',
  getParentRoute: () => rootRoute,
} as any)

const HubIndexRoute = HubIndexImport.update({
  path: '/hub/',
  getParentRoute: () => rootRoute,
} as any)

const WorkspacesWorkspaceIdRoute = WorkspacesWorkspaceIdImport.update({
  path: '/workspaces/$workspaceId',
  getParentRoute: () => rootRoute,
} as any)

const ProfileSettingsRoute = ProfileSettingsImport.update({
  path: '/profile/settings',
  getParentRoute: () => rootRoute,
} as any)

const ProfileWorkspaceIdRoute = ProfileWorkspaceIdImport.update({
  path: '/profile/$workspaceId',
  getParentRoute: () => rootRoute,
} as any)

const OauthInterstitialRoute = OauthInterstitialImport.update({
  path: '/oauth/interstitial',
  getParentRoute: () => rootRoute,
} as any)

const WorkspacesWorkspaceIdIndexRoute = WorkspacesWorkspaceIdIndexImport.update(
  {
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any,
)

const WorkspacesWorkspaceIdUsageRoute = WorkspacesWorkspaceIdUsageImport.update(
  {
    path: '/usage',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any,
)

const WorkspacesWorkspaceIdSettingsRoute =
  WorkspacesWorkspaceIdSettingsImport.update({
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdMembersRoute =
  WorkspacesWorkspaceIdMembersImport.update({
    path: '/members',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdHomeRoute = WorkspacesWorkspaceIdHomeImport.update({
  path: '/home',
  getParentRoute: () => WorkspacesWorkspaceIdRoute,
} as any)

const WorkspacesWorkspaceIdChatbotsRoute =
  WorkspacesWorkspaceIdChatbotsImport.update({
    path: '/chatbots',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsRoute = WorkspacesWorkspaceIdBotsImport.update({
  path: '/bots',
  getParentRoute: () => WorkspacesWorkspaceIdRoute,
} as any)

const WorkspacesWorkspaceIdAuditsRoute =
  WorkspacesWorkspaceIdAuditsImport.update({
    path: '/audits',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdSplatRoute = WorkspacesWorkspaceIdSplatImport.update(
  {
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any,
)

const HubIntegrationsIntegrationIdRoute =
  HubIntegrationsIntegrationIdImport.update({
    path: '/hub/integrations/$integrationId',
    getParentRoute: () => rootRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsIndexRoute =
  WorkspacesWorkspaceIdSettingsIndexImport.update({
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIndexRoute =
  WorkspacesWorkspaceIdIntegrationsIndexImport.update({
    path: '/integrations/',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsProfileRoute =
  WorkspacesWorkspaceIdSettingsProfileImport.update({
    path: '/profile',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsSplatRoute =
  WorkspacesWorkspaceIdSettingsSplatImport.update({
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdProfileSettingsRoute =
  WorkspacesWorkspaceIdProfileSettingsImport.update({
    path: '/profile/settings',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdImport.update({
    path: '/integrations/$integrationId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdChatbotsBotIdRoute =
  WorkspacesWorkspaceIdChatbotsBotIdImport.update({
    path: '/chatbots/$botId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdRoute =
  WorkspacesWorkspaceIdBotsBotIdImport.update({
    path: '/bots/$botId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsBillingIndexRoute =
  WorkspacesWorkspaceIdSettingsBillingIndexImport.update({
    path: '/billing/',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexImport.update({
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdIndexImport.update({
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdSettingsBillingPlansRoute =
  WorkspacesWorkspaceIdSettingsBillingPlansImport.update({
    path: '/billing/plans',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsImport.update({
    path: '/versions',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsImport.update({
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsImport.update({
    path: '/logs',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatImport.update({
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)

const WorkspacesWorkspaceIdChatbotsBotIdSplatRoute =
  WorkspacesWorkspaceIdChatbotsBotIdSplatImport.update({
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdChatbotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatImport.update({
    path: '/webchat',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdOverviewRoute =
  WorkspacesWorkspaceIdBotsBotIdOverviewImport.update({
    path: '/overview',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdLogsRoute =
  WorkspacesWorkspaceIdBotsBotIdLogsImport.update({
    path: '/logs',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdHitlRoute =
  WorkspacesWorkspaceIdBotsBotIdHitlImport.update({
    path: '/hitl',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdEventsRoute =
  WorkspacesWorkspaceIdBotsBotIdEventsImport.update({
    path: '/events',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdConfigurationVariablesRoute =
  WorkspacesWorkspaceIdBotsBotIdConfigurationVariablesImport.update({
    path: '/configuration-variables',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdChatRoute =
  WorkspacesWorkspaceIdBotsBotIdChatImport.update({
    path: '/chat',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute =
  WorkspacesWorkspaceIdBotsBotIdAnalyticsImport.update({
    path: '/analytics',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdSplatRoute =
  WorkspacesWorkspaceIdBotsBotIdSplatImport.update({
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdIssuesIndexImport.update({
    path: '/issues/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdConversationsIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsIndexImport.update({
    path: '/conversations/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatStylesRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatStylesImport.update({
    path: '/styles',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatShareRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatShareImport.update({
    path: '/share',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatGeneralRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatGeneralImport.update({
    path: '/general',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdWebchatAdvancedSettingsRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatAdvancedSettingsImport.update({
    path: '/advanced-settings',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute =
  WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdImport.update({
    path: '/issues/$issueId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdImport.update({
    path: '/conversations/$conversationId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

const WorkspacesWorkspaceIdBotsBotIdConversationsMessageMessageIdRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsMessageMessageIdImport.update({
    path: '/conversations/message/$messageId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/$': {
      preLoaderRoute: typeof SplatImport
      parentRoute: typeof rootRoute
    }
    '/forbidden': {
      preLoaderRoute: typeof ForbiddenImport
      parentRoute: typeof rootRoute
    }
    '/oauth/interstitial': {
      preLoaderRoute: typeof OauthInterstitialImport
      parentRoute: typeof rootRoute
    }
    '/profile/$workspaceId': {
      preLoaderRoute: typeof ProfileWorkspaceIdImport
      parentRoute: typeof rootRoute
    }
    '/profile/settings': {
      preLoaderRoute: typeof ProfileSettingsImport
      parentRoute: typeof rootRoute
    }
    '/workspaces/$workspaceId': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdImport
      parentRoute: typeof rootRoute
    }
    '/hub/': {
      preLoaderRoute: typeof HubIndexImport
      parentRoute: typeof rootRoute
    }
    '/workspaces/': {
      preLoaderRoute: typeof WorkspacesIndexImport
      parentRoute: typeof rootRoute
    }
    '/hub/integrations/$integrationId': {
      preLoaderRoute: typeof HubIntegrationsIntegrationIdImport
      parentRoute: typeof rootRoute
    }
    '/workspaces/$workspaceId/$': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/audits': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdAuditsImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/bots': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/chatbots': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/home': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdHomeImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/members': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdMembersImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/settings': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/usage': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/bots/$botId': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/chatbots/$botId': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/profile/settings': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdProfileSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/settings/$': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/settings/profile': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsProfileImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/integrations/': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdImport
    }
    '/workspaces/$workspaceId/settings/': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/bots/$botId/$': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/analytics': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/chat': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdChatImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/configuration-variables': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConfigurationVariablesImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/events': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdEventsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/hitl': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdHitlImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/logs': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdLogsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/overview': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdOverviewImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/chatbots/$botId/$': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/$': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/logs': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/settings': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/versions': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/settings/billing/plans': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsBillingPlansImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/bots/$botId/': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/integrations/$integrationId/': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdImport
    }
    '/workspaces/$workspaceId/settings/billing/': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsBillingIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsImport
    }
    '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/issues/$issueId': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/advanced-settings': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatAdvancedSettingsImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/general': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatGeneralImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/share': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatShareImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/styles': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatStylesImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatImport
    }
    '/workspaces/$workspaceId/bots/$botId/conversations/': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/issues/': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
    '/workspaces/$workspaceId/bots/$botId/conversations/message/$messageId': {
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsMessageMessageIdImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  SplatRoute,
  ForbiddenRoute,
  OauthInterstitialRoute,
  ProfileWorkspaceIdRoute,
  ProfileSettingsRoute,
  WorkspacesWorkspaceIdRoute.addChildren([
    WorkspacesWorkspaceIdSplatRoute,
    WorkspacesWorkspaceIdAuditsRoute,
    WorkspacesWorkspaceIdBotsRoute,
    WorkspacesWorkspaceIdChatbotsRoute,
    WorkspacesWorkspaceIdHomeRoute,
    WorkspacesWorkspaceIdMembersRoute,
    WorkspacesWorkspaceIdSettingsRoute.addChildren([
      WorkspacesWorkspaceIdSettingsSplatRoute,
      WorkspacesWorkspaceIdSettingsProfileRoute,
      WorkspacesWorkspaceIdSettingsIndexRoute,
      WorkspacesWorkspaceIdSettingsBillingPlansRoute,
      WorkspacesWorkspaceIdSettingsBillingIndexRoute,
    ]),
    WorkspacesWorkspaceIdUsageRoute,
    WorkspacesWorkspaceIdIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdRoute.addChildren([
      WorkspacesWorkspaceIdBotsBotIdSplatRoute,
      WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute,
      WorkspacesWorkspaceIdBotsBotIdChatRoute,
      WorkspacesWorkspaceIdBotsBotIdConfigurationVariablesRoute,
      WorkspacesWorkspaceIdBotsBotIdEventsRoute,
      WorkspacesWorkspaceIdBotsBotIdHitlRoute,
      WorkspacesWorkspaceIdBotsBotIdLogsRoute,
      WorkspacesWorkspaceIdBotsBotIdOverviewRoute,
      WorkspacesWorkspaceIdBotsBotIdWebchatRoute.addChildren([
        WorkspacesWorkspaceIdBotsBotIdWebchatAdvancedSettingsRoute,
        WorkspacesWorkspaceIdBotsBotIdWebchatGeneralRoute,
        WorkspacesWorkspaceIdBotsBotIdWebchatShareRoute,
        WorkspacesWorkspaceIdBotsBotIdWebchatStylesRoute,
      ]),
      WorkspacesWorkspaceIdBotsBotIdIndexRoute,
      WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute,
      WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute,
      WorkspacesWorkspaceIdBotsBotIdConversationsIndexRoute,
      WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute,
      WorkspacesWorkspaceIdBotsBotIdConversationsMessageMessageIdRoute,
    ]),
    WorkspacesWorkspaceIdChatbotsBotIdRoute.addChildren([
      WorkspacesWorkspaceIdChatbotsBotIdSplatRoute,
    ]),
    WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute.addChildren([
      WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute,
      WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute,
      WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute,
      WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute,
      WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute,
    ]),
    WorkspacesWorkspaceIdProfileSettingsRoute,
    WorkspacesWorkspaceIdIntegrationsIndexRoute,
  ]),
  HubIndexRoute,
  WorkspacesIndexRoute,
  HubIntegrationsIntegrationIdRoute,
])
